export default "__VITE_ASSET__CAQhp_Ei__"